import { useContext } from "react";
import {
  UnorderedList,
  ListItem,
  Table,
  Thead,
  Tbody,
  Text,
  Tr,
  Th,
  Td,
  TableContainer,
  Button,
  Box,
  Flex,
} from "@chakra-ui/react";

// Components
import Alert from "components/Alert";

// Providers
import { StakeContext } from "providers/StakeProvider";

const Claim = () => {
  const { withdrawals, handleClaim, config } = useContext(StakeContext);

  return (
    <>
      <Alert type="info" withIcon={false} _dark={{ bg: "brand.background" }}>
        <UnorderedList spacing={3} fontSize="14px" px="0.5rem">
          <ListItem>
            You will be able to withdraw your tokens after the withdraw request
            has been processed. To unstake your amount go to{" "}
            <Text as="span" fontFamily="medium">
              Unstake
            </Text>{" "}
            Tab.
          </ListItem>
        </UnorderedList>
      </Alert>
      {withdrawals.length > 0 ? (
        <Box
          fontSize="14px"
          mt="1rem"
          bg="brand.background"
          p={4}
          borderRadius="8px"
        >
          <TableContainer
            h={{ base: "230px", md: "198px", xl: "190px" }}
            overflowY="auto"
          >
            <Table variant="simple">
              <Thead>
                <Tr fontSize="12px">
                  <Th fontFamily="light" width={{ base: "80px", xl: "160px" }}>
                    Amount
                  </Th>
                  <Th fontFamily="light">Release Time</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                {withdrawals.map((withdrawal) => {
                  const { amount, message, isClaimable, id } = withdrawal;

                  return (
                    <Tr key={`${amount}-${id}`}>
                      <Td fontFamily="medium" whiteSpace="pre-wrap">
                        {amount} {config.nativeCurrency.symbol}
                      </Td>
                      <Td whiteSpace="pre-wrap">{message}</Td>
                      <Td textAlign="right" paddingRight="0">
                        <Button
                          bg="brand.primary"
                          color="brand.textLight"
                          h="36px"
                          onClick={
                            isClaimable
                              ? () => handleClaim(id, amount)
                              : undefined
                          }
                          disabled={!isClaimable}
                        >
                          Withdraw
                        </Button>
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <Flex
          h={{ base: "246px", md: "214px" }}
          justifyContent="center"
          alignItems="center"
        >
          <Text>No claims found</Text>
        </Flex>
      )}
    </>
  );
};

export default Claim;
